module.exports = __webpack_public_path__ + "img/cqc.6b244aab.svg";